import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { bindActionCreators } from "redux";
import { ToastContainer } from "react-toastify";
import { removeAllStorage, setStorageItem } from "../../helpers/";

import { onClickUpdatePassword } from "../../modules/actions/";

class UpdatePassword extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      code: this.props.match.params.code,
      password: "",
      confirmPassword: "",
      disableSubmit: false,
    };

    this.onChangeHandelUserInput = this.onChangeHandelUserInput.bind(this);
    this.onTextKeyPress = this.onTextKeyPress.bind(this);
  }

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickUpdatePasssword(evt);
    }
  };

  onClickUpdatePasssword = () => {
    this.setState({ disableSubmit: true });

    this.props.onClickUpdatePassword({
      code: this.state.code,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
    });

    setTimeout(
      () =>
        this.setState({
          password: "",
          confirmPassword: "",
          disableSubmit: false,
        }),
      2500
    );
  };

  render() {
    const { password, confirmPassword, disableSubmit } = this.state;

    return (
      <div className="container">
        <div className="col-md-6 offset-md-3">
          <div className="beforeLoginHolder">
            <div className="card">
              <h3 className="blHeader">SAQ Generator</h3>
              <h4 className="blSubheader">Update Password</h4>
              <ToastContainer />
              <div className="inputGroup">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  name="password"
                  value={password}
                  onChange={(evt) => this.onChangeHandelUserInput(evt)}
                  onKeyPress={(evt) => this.onTextKeyPress(evt)}
                />
              </div>
              <div className="inputGroup">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(evt) => this.onChangeHandelUserInput(evt)}
                  onKeyPress={(evt) => this.onTextKeyPress(evt)}
                />
              </div>
              <button
                className="btn btn-primary"
                onClick={() => this.onClickUpdatePasssword()}
                disabled={disableSubmit}
              >
                Update Password
              </button>
              <div className="d-flex justify-content-between">
                <button
                  className="btn btn-sm btn-link"
                  onClick={() => {
                    this.props.history.push("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onClickUpdatePassword,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePassword);
